import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { CartPreview } from '../bot-core/types/chat.types';
import { formatBotPrice } from './search-results/formatBotPrice';

const ICONS: Record<string, string> = {
  flight: '✈️',
  hotel: '🏨',
  package: '📦',
  activity: '🎯',
  event: '🎫',
};

interface Props {
  /** Cart snapshot from bot:done.cart_preview */
  cartPreview: CartPreview;
}

const CartPreviewCard: React.FC<Props> = ({ cartPreview }) => {
  const t = useSelector((s: RootState) => (s.config.translations as any)?.bot);
  const tk = t?.checkout ?? {};

  const totalLabel = tk.total ?? 'Total';
  const travellersLabel = tk.travellers ?? 'Travellers';
  const titleLabel = tk.title;

  const pax = cartPreview.travellers;
  const paxText = pax
    ? [
        pax.adults > 0 ? `${pax.adults} adult${pax.adults > 1 ? 's' : ''}` : null,
        pax.children > 0 ? `${pax.children} child${pax.children > 1 ? 'ren' : ''}` : null,
        pax.infants > 0 ? `${pax.infants} infant${pax.infants > 1 ? 's' : ''}` : null,
      ]
        .filter(Boolean)
        .join(' · ')
    : null;

  return (
    <div className="bot-cart-preview">
      <div className="bot-cart-preview__title">🗺️ {titleLabel}</div>
      <div className="bot-cart-preview__items">
        {cartPreview.items.map((item) => (
          <div
            key={item.cart_item_id}
            className="bot-cart-preview__item"
            data-cart-item-id={item.cart_item_id}
          >
            <span className="bot-cart-preview__icon">
              {ICONS[item.product_type] ?? '📌'}
            </span>
            <div className="bot-cart-preview__info">
              <div className="bot-cart-preview__name">{item.display_name}</div>
              <div className="bot-cart-preview__summary">{item.display_summary}</div>
            </div>
            <div className="bot-cart-preview__price">
              {item.currency} {formatBotPrice(item.price)}
            </div>
          </div>
        ))}
      </div>
      <div className="bot-cart-preview__footer">
        {paxText && (
          <div className="bot-cart-preview__pax">
            <span className="bot-cart-preview__pax-label">{travellersLabel}:</span>{' '}
            {paxText}
          </div>
        )}
        <div className="bot-cart-preview__total">
          <span>{totalLabel}</span>
          <strong>
            {cartPreview.currency} {formatBotPrice(cartPreview.total_estimated_price)}
          </strong>
        </div>
      </div>
    </div>
  );
};

export default CartPreviewCard;
